import { render, staticRenderFns } from "./FormAdicionarFornecedor.vue?vue&type=template&id=6db9ca11"
import script from "./FormAdicionarFornecedor.vue?vue&type=script&lang=js"
export * from "./FormAdicionarFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports